import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dialog"];

  connect() {
    this.dialogElement = this.element.querySelector("dialog");
  }

  open(event) {
    event.preventDefault();
    if (this.dialogElement) {
      this.dialogElement.showModal();
    }
  }

  close(event) {
    if (event) event.preventDefault();
    if (this.dialogElement) {
      this.dialogElement.close();
    }
  }
}

